<template>
  <div class="paragraph-m_h mb-6 text-secondary">
    <div v-if="externalIntegration?.integrationId">
      id подключения:
      <b>
        {<span>{{ externalIntegration.integrationId }}</span
        >}
      </b>
      <copy-to-clipboard class="d-inline ml-1" :text="externalIntegration.integrationId" />
      <br />
      <br />
    </div>
    <template v-if="channelManagerCode === ChannelManagerCode.TravelLine">
      Перейдите
      <a v-if="externalIntegration?.externalIntegration.integrationUrl" :href="externalIntegration?.externalIntegration.integrationUrl" target="blank" class="link"
        >по ссылке</a>
      <span v-else>в ваш ЛК TravelLine</span>, убедитесь в том, что вы выполнили все необходимые настройки. После успешной настройки, статус вашего
      подключения в ЛК TravelLine изменится на статус: <b class="text-green">«Работает»</b>.
    </template>
    <template v-else-if="channelManagerCode === ChannelManagerCode.Exely">
      Перейдите к настройкам подключения
      <a v-if="externalIntegration?.externalIntegration.integrationUrl" :href="externalIntegration?.externalIntegration.integrationUrl" target="blank" class="link"
        >по ссылке</a>
      <span v-else>в ваш ЛК Exely</span>, убедитесь в том, что вы выполнили все необходимые настройки. После успешной настройки, статус вашего
      подключения в ЛК Exely изменится на статус: <b class="text-green">«Работает»</b>.
    </template>

    <template v-if="isDialog">
      <br />
      <br />
      <span>
        После настройки обновите данные мастера или перезапустите его. Если ошибка повторится, обратитесь в
        <router-link :to="{ name: RouteNames.Support }" class="link"> Поддержку</router-link>
        .
      </span>
    </template>
  </div>

  <v-img :src="channelManagerCode === ChannelManagerCode.TravelLine ? TLImg : ExelyImg" />
</template>

<script setup lang="ts">
import TLImg from '@/assets/img/pages/tariffs/channel-manager/connection-tl.webp';
import ExelyImg from '@/assets/img/pages/tariffs/channel-manager/exely-side-settings.webp';
import CopyToClipboard from '@/core/components/buttons/CopyToClipboard.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { ChannelManagerCode } from '@/graphql/generated';
import { useTravelLineStore } from '@/parts/tariffs/store/travelLine';

defineProps<{
  isDialog?: boolean;
}>();

const { externalIntegration, channelManagerCode } = useTravelLineStore();
</script>

<style scoped lang="scss"></style>
